import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { FaUser, FaLock, FaSignInAlt, FaShieldAlt, FaMobileAlt, FaDownload } from 'react-icons/fa';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(username, password);
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <main className="login-page" dir="rtl">
      <section className="login-shell" aria-labelledby="login-title">
        {/* Login Card */}
        <div className="login-card login-card--minimal">
          {/* Header Section - Centered */}
          <div className="login-card-header login-card-header--minimal">
            <div className="login-brand-center">
              <div className="login-brand-icon" aria-hidden="true">
                <FaShieldAlt />
              </div>
              <span className="login-brand-caption">
                البنية التحتية للاتصالات والتقنية
              </span>
            </div>
            
            <h1 id="login-title" className="login-title">
              تسجيل الدخول
            </h1>
            
            <p className="login-subtitle">
              الوصول إلى نظام الدعم الفني بصلاحياتك المعتمدة.
            </p>
          </div>

          {/* Form Section */}
          <div className="login-card-body">
            {error && (
              <div className="login-alert" role="alert">
                {error}
              </div>
            )}

            <form className="login-form" onSubmit={handleSubmit} autoComplete="off">
              <div className="login-form-group">
                <label className="login-label" htmlFor="login-username">
                  اسم المستخدم
                </label>
                <div className="login-input-wrap">
                  <FaUser className="login-input-icon" />
                  <input
                    id="login-username"
                    type="text"
                    className="login-input"
                    placeholder="أدخل اسم المستخدم"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    disabled={loading}
                    autoComplete="username"
                  />
                </div>
              </div>

              <div className="login-form-group">
                <label className="login-label" htmlFor="login-password">
                  كلمة المرور
                </label>
                <div className="login-input-wrap">
                  <FaLock className="login-input-icon" />
                  <input
                    id="login-password"
                    type="password"
                    className="login-input"
                    placeholder="أدخل كلمة المرور"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={loading}
                    autoComplete="current-password"
                  />
                </div>
              </div>

              <button type="submit" className="login-btn" disabled={loading}>
                {loading ? (
                  <>
                    <span className="login-spinner" aria-hidden="true" />
                    جاري تسجيل الدخول...
                  </>
                ) : (
                  <>
                    <FaSignInAlt />
                    دخول النظام
                  </>
                )}
              </button>
            </form>
          </div>
        </div>

        {/* Android App Promotion Card */}
        <div className="login-app-promotion">
          <div className="app-promo-header">
            <div className="app-promo-icon">
              <FaMobileAlt />
            </div>
          </div>
          <div className="app-promo-content">
            <h2 className="app-promo-title">تطبيق الأندرويد للفنيين</h2>
            <p className="app-promo-text">
              لأفضل تجربة استخدام، يُفضّل تثبيت تطبيق الأندرويد الخاص بالنظام واستخدامه على الهاتف. التطبيق أسرع وأسهل للفنيين أثناء العمل الميداني.
            </p>
            <div className="app-promo-actions">
              <a 
                href="/downloads/app/technician-app.apk" 
                className="app-download-btn"
                download="technician-app.apk"
              >
                <FaDownload className="btn-icon" />
                تحميل تطبيق الأندرويد
              </a>
            </div>
            <div className="app-promo-notes">
              <p>• قد يلزم السماح بالتثبيت من مصدر خارجي (External Sources) في إعدادات الهاتف.</p>
              <p>• التطبيق مخصص للاستخدام الداخلي لفنيي المنظومة فقط.</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Login;
